export const getPlanPropertiesPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `benefitPackagingDetail.plans[${planIndex}]`;

  return {
    plans: 'benefitPackagingDetail.plans',
    planName: `${parentPath}.planName`,
    planCd: `${parentPath}.planCd`,
  }
}